<div class="dropdown text-end">
  <a href="#" class="d-block link-dark text-decoration-none position-relative" id="dropdownNotification"
    data-bs-toggle="dropdown" aria-expanded="false">

    <i class="fa-solid fa-bell fs-4" [ngClass]="notification < 10 ? 'me-2' : 'me-3'">
    </i>

    @if(notification > 0){
    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
      {{notification}}
      <span class="visually-hidden">novas notificações</span>
    </span>
    }
  </a>
  <ul class="dropdown-menu dropdown-menu-end shadow" aria-labelledby="dropdownNotification">
    <li class="dropdown-header">{{ title()}}</li>
    <li>
      <hr class="dropdown-divider">
    </li>
    <li>
      @for (item of notificationObject; track $index) {
      <a class="dropdown-item" [routerLink]="[item?.route]">
        <div class="d-flex align-items-start">
          <i class="fa-solid {{ item?.icon?.color }}" [class]=" item?.icon?.name  + ' me-2'" style="margin-top: 5px;"
            [style.color]="item?.icon?.color"></i>
          <div>
            <div><strong>{{ item?.text}}</strong></div>
            <small>{{ item?.subtitle}}</small>
          </div>
        </div>
      </a>
      }
    </li>
  </ul>
</div>
